<template>
    <div class="releaseSearch">
        <p class="addtext" v-if='addtext'>{{$t('releaseSearch.report')}}</p>
        <div class="main">
        	<div class="disable" v-if="isable"></div>
            <div>
                <div class="title" v-if="title">
                    <el-input v-model="title" :placeholder="$t('releaseSearch.title')" maxlength='20'></el-input>
                </div>
                <div class="describe">
                	<span>{{$t('releaseSearch.mastermessage')}}:</span>
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" maxlength='200'  v-model="textarea2" :placeholder="$t('releaseSearch.decription')" @change='Verificationtext'>
                    </el-input>
                </div>
                <div class="loseplace">
                	<span><img src="../../../static/img/account2/lostaddr.png" alt="" />{{$t('mysearch.losePlace')}}</span>
                    <p @click="changeplace">{{place}}</p>
                </div>
 				<div class="time">
                    <p><img src="../../../static/img/account2/losttime.png" alt="" />{{$t('releaseSearch.losttime')}}</p>
                    <div class="block">
                        <el-date-picker v-model="losttime" type="date" :default-value="losttime" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @focus='disapper' ref='datetime' @change='vertime' >
                        </el-date-picker>
                    </div>
                    <span class="danger" v-show="flag2" style="margin-left:20px;">{{$t('releaseSearch.nottime')}}</span>
                </div>
                <div style="margin-top:15px;display:none;">
                    <div id="allmap" style="width: 90%;height:200px;border: 1px solid gray;overflow:hidden;margin:10px auto;"></div>
                </div>
                <div class="petphoto">
                    <p><img src="../../../static/img/account2/lostimg.png" alt="" />{{$t('releaseSearch.petImg')}}</p>
                    
                    <template v-if='editimg'>
                    	
	                    <span v-if="message[0]" @click="removeimg"><img src='../../image/delete.png' class="delete" /></span>
	                    <img :src="message[0]?message[0]:avatar1" @click.stop="uploadHeadImg" v-show="isshow"/>
	                    <canvas ref="can" style="width: 60px;height: 60px;margin-right:20px;"v-show="showflag" ></canvas>
	                    <input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />

	                    <span v-if="message[1]" @click="removeimg1"><img src='../../image/delete.png' class="delete1" /></span>
	                    <img :src="message[1]?message[1]:avatar1" @click.stop="uploadHeadImg1"v-show="isshow1"/>
	                    <canvas ref="can1"style="width: 60px;height: 60px;margin-right: 20px;"v-show="showflag1" ></canvas>
	                    <input type="file" accept="image/*" @change="handleFile1" class="hiddenInput1"/>
	                    
	                    
	                    <span v-if="message[2]" @click="removeimg2"><img src='../../image/delete.png' class="delete2" /></span>
	                    <img :src="message[2]?message[2]:avatar1" @click.stop="uploadHeadImg2" v-show="isshow2"/>
	                    <canvas ref="can2" style="width: 60px;height: 60px;margin-right: 20px;" v-show="showflag2" ></canvas>
	                    <input type="file" accept="image/*" @change="handleFile2" class="hiddenInput2"/>

                    </template>
                	<template v-if='showimg'>
                		<template v-for="item in message">
                			<!--<img v-if='item' :src="item" @click="clickImg($event)"/>--> 
                			<img v-if='item' :src="item" preview="0"/>
                		</template>
                	</template>
                	<!-- 放大图片 -->
        			<big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>
                	<template v-if='noshowimg'>
                		<img  :src="avatar11"  @click="clickImg($event)"/>
                		<img  :src="avatar11"  @click="clickImg($event)"/>
                		<img  :src="avatar11"  @click="clickImg($event)"/>
                	</template>
                </div>
                <el-button type="primary" v-if="!isable" style='margin:20px auto;display: block;width: 75%;' @click='save'>{{$t('releaseSearch.preserve')}}</el-button>
                <el-button type="primary" v-if="!isable" style='margin:20px auto;display: block;width: 75%;    margin-top: 0;' @click='cancel'>{{$t('releaseSearch.cancel')}}</el-button>
            </div>
        </div>
        <mapinfo ref='bannerto' @adress='adress'></mapinfo>
    </div>
    
 
    
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import { updatePublish } from "../../ClientServerApi/index.js";
import { updateBasicInfo} from "../../apiNew/index.js";
import { getLoginUser } from "../../api/index.js";
import bridge from"../../store/bus.js";
import Qs from "qs";
import BMap from "BMap";
import EXIF from "exif-js/exif.js";
import mapinfo from "../myAccount/mapinfo";
import BigImg from '../myAccount/BigImg.vue';
export default {
    name: "lostpetinfos",
    data() {
        return {
            title: false,
            addtext:true,
            losttime: "",
            avatar1: require("../../image/addphoto.png"),
            avatar:"",
            avatar2:"",
            avatar3:"",
            editimg:false,//编辑照片
            showimg:true,//展示照片
            avatar11: require("../../image/notphoto.png"),
			noshowimg:false,
            showimg11:false,
            showimg12:false,
            showimg13:false,
            imgflag: false,
            imgflag1: false,
            imgflag2: false,
            imgchoose: true,
            showflag: false,
            showflag1: false,
            showflag2: false,
            isable:true,//遮罩层屏蔽编辑操作,判读保存取消按钮显示
            isshow: true,
            isshow1: true,
            isshow2: true,
            petimg: require("../../image/addphoto.png"),
            msg: this.$t("addpet.trueAdd"),
            tmsg: this.$t("addpet.trueAdd"),
            cmsg: this.$t("addpet.submiting"),
            id: "",
            lat: "",
            lng: "",
            mobile: "",
            email: "",
            address: "",
            nickname: "",
            personinfo: "",
            lossimg:[],
            featurePhoto: [],
            textarea2: "",
            value: "",
            options: [
                {
                    value: "1",
                    label: this.$t("prompt.openemail")
                },
                {
                    value: "2",
                    label: this.$t("prompt.openphone")
                },
                {
                    value: "3",
                    label: this.$t("prompt.openall")
                }
            ],
            isShow: false,
            choose: "",
            place: "",
            flag: false,
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: true,
            flag5: false,
            flag6: false,
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now();
                }
            },
            info:{
	            menuC:'',
	            cords:'',
	            lostpetinfos:'',
	            lostsign:'',
	            ifedit:'',
	            isable:'',
	            lossbtn:'',
	            lossTime:'',
				petname:'',
		  		petbelong:'',
		  		value:'',
		  		portrait:'',
		  		nc:'',
		  		em:'',
		  		phone:'',
		  		adr:'',
	         }, 
            scrollY:0,
            childformparent:'',
            showImg:false,
            imgSrc: ''
        };
    },
    props:["message"],
    inject:["reload"], 
    components: {
        mapinfo,
        'big-img':BigImg
    },
    
    watch:{
    	textarea2(newvalue, oldvalue){
			let filter =this.filter(newvalue);
			if(filter==true){
				this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
					confirmButtonText: this.$t("prompt.sure"),
					dangerouslyUseHTMLString: true
					});
				this.textarea2= oldvalue;
				return false;
			}
     	},
    },
    mounted() {
    	//接收到菜单组件传来指令
    	var self = this;
    	bridge.$on("editinfos",function(msg){
            self.isable = msg.isable;
            self.editimg=msg.editimg;//编辑照片
            self.showimg=msg.showimg;//不展示照片
            self.noshowimg=msg.showimg;//不展示默认照片
            self.addtext =msg.addtext;//编辑提示
		});
		//console.log(this.message)
		if(this.showimg==true && this.message.length==0){
			this.noshowimg=true;
		}else{
			this.noshowimg=false;
		}
    },
    created() {
        //检查吊牌是否传来信息
        if(localStorage.mytagchang=="mytagchang"){
    		this.mytagchang();
    	}else{
    		this.getNowFormatDate();//获取当前时间  
    	}
    	if(localStorage.title=='false'){
    		this.addtext=false;
    		localStorage.setItem('title','');
    	}
    	setTimeout(() =>{
			this.place = localStorage.lostPlace;			
		},1000);	
    },
    methods: {
    	//====过滤表情字符=====
    filter(substring){
		    if(substring){
		        for ( var i = 0; i < substring.length; i++) {
		            var hs = substring.charCodeAt(i);
		            if (0xd800 <= hs && hs <= 0xdbff) {
		                if (substring.length > 1) {
		                    var ls = substring.charCodeAt(i + 1);
		                    var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
		                    if (0x1d000 <= uc && uc <= 0x1f77f) {
		                        return true;
		                    }
		                }
		            } else if (substring.length > 1) {
		                var ls = substring.charCodeAt(i + 1);
		                if (ls == 0x20e3) {
		                    return true;
		                }
		            } else {
		                if (0x2100 <= hs && hs <= 0x27ff) {
		                    return true;
		                } else if (0x2B05 <= hs && hs <= 0x2b07) {
		                    return true;
		                } else if (0x2934 <= hs && hs <= 0x2935) {
		                    return true;
		                } else if (0x3297 <= hs && hs <= 0x3299) {
		                    return true;
		                } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
		                    || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
		                    || hs == 0x2b50) {
		                    return true;
		                }
		            }
		        }
		    }
		},
		//获取当前时间
	  	getNowFormatDate() {	  
		  	var date = new Date();
		  	var year = date.getFullYear();
		  	var month = date.getMonth() + 1;
		  	var strDate = date.getDate();
		  	if (month >= 1 && month <= 9) {
		   	 month = "0" + month;
		  	}
		  	if (strDate >= 0 && strDate <= 9) {
		    strDate = "0" + strDate;
		  	}
		  	var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      		var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      		var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		  	var currentdate = year + '-' + month + '-' + strDate +' ' + h + m + s;
		  	this.losttime = currentdate;
		  	localStorage.setItem('lossTime',currentdate)
		},

      
//更新主人信息=======
		updateBasicInfo(){
			var nc =localStorage.nc;
//			console.log(nc)
			if( nc=='undefined'){
				this.$alert("<p>" + this.$t("mynewsedit.EnterMastername") + "</p>", {
				confirmButtonText: this.$t("prompt.sure"),
				dangerouslyUseHTMLString: true
				});
				return false;
			}
			var em =localStorage.em;
			if( em=='undefined'){
				em='';
			}
			var phone =localStorage.phone;
			if( phone=='undefined'){
				phone='';
			}
			var adr = localStorage.adr;
			if( adr=='undefined'){
				adr='';
			}
			var params = Qs.stringify({
			   	nickname : nc,
	  			email : em,
	  			mobile : phone,
	  			address : adr,   
	  			sex:"0",
			});
			updateBasicInfo(params)
		    .then(res => {
		      if (res.data.header.status == 1000) {
				//console.log('更新主人信息成功！')
		      }else{
			      this.$alert("<p>" + res.data.header.message + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						return false;
		      }
		    })
		    .catch(error => {
		      console.log(error);
		    });
	    
		},
//修改协寻信息=======
		updatePublish(){
			let tempData = [];
			for (let i = 0; i < this.message.length; i++) {
				if (this.message[i] != undefined){
					tempData.push(this.message[i]);
				}
			}
			if(tempData[0] != undefined && tempData[0].indexOf('http://')==-1){
				tempData[0]=tempData[0].split(',')[1];
			}
			if(tempData[1] != undefined && tempData[1].indexOf('http://')==-1){
				tempData[1]=tempData[1].split(',')[1];
			}
			
			if(tempData[2] != undefined && tempData[2].indexOf('http://')==-1){
				tempData[2]=tempData[2].split(',')[1];
			}
			let th = this;
			let pic='';
          for(var i=0;i<tempData.length;i++){
            if(i>0){
              pic+=",";
            }
            pic+=tempData[i];
          }
			if(!this.textarea2){
				this.textarea2= '';
			}
			
			if(pic.length==0){
				pic='';
			}
			if(this.textarea2==''){
				this.textarea2=this.$t('releaseSearch.decription');
			}
			var params = Qs.stringify({
			    publishId:localStorage.publishId,
 				content:this.textarea2,
 				lat:this.lat,
 				lon:this.lng,
 				mobile:localStorage.mobile,
 				email:localStorage.email,
 				loseTime:this.losttime,
 				lostPlace:this.place,
 				featurePhoto:pic,
 				isOpen:1,
			});
			updatePublish(params)
		    .then(res => {
		      if (res.data.header.status == 1000) {
					//console.log('修改协寻信息成功！')
 					th.$nextTick(() => (
 						th.message = JSON.parse(res.data.data.featurePhoto)
 					))
 					this.reload();
		      }else{
			      this.$alert("<p>" + res.data.header.message + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
					return false;
		      }
		    })
		    .catch(error => {
		      console.log(error);
		    });
		},
        Verificationtext() {
            if (this.textarea2.length > 0) {
                this.flag1 = false;
            }
        },
        adress(data) {
            if (data != "") {
                this.place = data;
            }
        },
        changeplace() {
        	this.$emit("Gotop",this.scrollY)	
            this.$refs.bannerto.show();
        },
        isinfo(){
            this.Scroll.destroy()
        },
        leinfo(e){
            if(e==false){
            this._initScroll()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.info.blur()
            }
        },
// =========打开图片1上传========
        uploadHeadImg: function(e) {
                this.$el.querySelector(".hiddenInput").click();
        },
        // 将头像显示
        handleFile(e) {
            var th = this;
            th.imgflag = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag = false;
                    th.isshow = true;
                    
                    let temp = th.message;
                    temp[0] = res.result;
                    th.message = [];
                    for(let i=0;i<temp.length;i++){
                    	th.message.push(temp[i])
                    }
                    //console.log('th.message:',th.message)
                } else {
                    th.compress(res.result, Orientation);
                }
            };
        },
        //图片压缩
        compress(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag = true;
            th.isshow = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                var canvas = th.$refs.can;
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 1);
                let temp = th.message;
                temp[0] = base64;
                th.message = [];
                for(let i=0;i<temp.length;i++){
                	th.message.push(temp[i])
                }
            };
        },
//===== 打开图片2上传==============
        uploadHeadImg1: function() {
                this.$el.querySelector(".hiddenInput1").click();
        },
        // 将头像显示
        handleFile1: function(e) {
            var th = this;
            this.imgflag1 = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag1 = false;
                    th.isshow1 = true;
                    
                    let temp = th.message;
                    temp[1] = res.result;
                    th.message = [];
                    for(let i=0;i<temp.length;i++){
                    	th.message.push(temp[i])
                    }
                } else {
                    th.compress1(res.result, Orientation);
                }
            };
        },
        compress1(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag1 = true;
            th.isshow1 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can1;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 1);
                let temp = th.message;
                temp[1] = base64;
                th.message = [];
                for(let i=0;i<temp.length;i++){
                	th.message.push(temp[i])
                }
            };
        },
// ==========打开图片3上传=======
        uploadHeadImg2: function() {
                this.$el.querySelector(".hiddenInput2").click();
        },
        // 将头像显示
        handleFile2: function(e) {
            var th = this;
            this.imgflag2 = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag2 = false;
                    th.isshow2 = true;
                    
                    let temp = th.message;
                    temp[2] = res.result;
                    th.message = [];
                    for(let i=0;i<temp.length;i++){
                    	th.message.push(temp[i])
                    }
                } else {
                    th.compress2(res.result, Orientation);
                }
            };
        }, 
        compress2(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag2 = true;
            th.isshow2 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can2;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 1);
                	let temp = th.message;
                    temp[2] = base64;
                    th.message = [];
                    for(let i=0;i<temp.length;i++){
                    	th.message.push(temp[i])
                    }
            };
        },
        
        editInfo(info){//重新打开编辑效果
  		this.isable = info.isable;//禁止编辑主人信息
  		},
        disapper() {
            this.$refs.datetime.blur();
        },
        vertime() {
            if (this.losttime.length > 0) {
                this.flag2 = false;
            }
            var date = new Date();
		  	var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      		var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      		var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            this.losttime =this.losttime+' '+h+m+s;
            localStorage.setItem('lossTime',this.losttime);
        },
        petid(data) {
            this.id = data;
        },
        listenIsShow(data) {
            //监听获得子组件choosePet传来的关闭信息值
            this.isShow = data;
            this.imgchoose = data;
        },
        pet(data) {
            //获取选取的宠物头像
            this.petimg = data.portrait;
            this.id = data.id;
        },
        //删除已选的照片
        removeimg() {
            this.message.splice(0,1);
            this.isshow = true;
            this.avatar = '';
        },
        removeimg1() {
            this.message.splice(1,1);
            this.isshow1 = true;
            this.avatar2 = '';
        },
        removeimg2() {
            this.message.splice(2,1);
            this.isshow2 = true;
            this.avatar3 = '';
        },
        //保存更新
		save(){
			this.info.lossTime= localStorage.lossTime;
			this.isable= true;
			this.editimg=false,//编辑照片
            this.showimg=true,//展示照片
            this.noshowimg=false;//不展示默认图片
            this.addtext=true;
			this.info.lostpetinfos = true;//编辑宠物组件显示
			this.info.lostsign = true;//走失标志显示
			this.info.ifedit = false;//宠物信息编辑打开
			this.info.isable = true;//主人信息编辑打开
			this.info.lossbtn = false;//发布丢失按钮打开
			this.updateBasicInfo();
			this.updatePublish();
			this.$emit("editinfoss",this.info)				
		},
		cancel(){
			this.reload();
		},
		//根据吊牌信息改变协寻内容
		mytagchang(){
	        setTimeout(() =>{
				this.place = localStorage.lostPlace;
				this.losttime = localStorage.lossTime;
	        	this.textarea2 = localStorage.content;
			},500);		
	        localStorage.setItem('mytagchang','');//清空吊牌传导信号
		},
		
	    clickImg(e) {
            this.showImg = true;
            // 获取当前图片地址
            this.imgSrc = e.currentTarget.src;
        },
        viewImg(){
            this.showImg = false;
        },
		
		

    }
};
</script>
<style>
.releaseSearch {
	position: relative;
    width: 92%;
    height: 32rem;
    margin-left: 4%;
}
.title .el-input__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.title .el-input__inner:hover {
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.releaseSearch .el-textarea__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
    padding: 0;
}

.releaseSearch .el-button--primary {
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
.releaseSearch .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    border: none;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
	width: 90%;
}
.el-input--prefix .el-input__inner{
	height: 3rem;
	line-height: 3rem;
	border: none;
	text-align: right;
	padding: 0;
	font-size: .8rem;
	color:#606266;
}
.el-popper{
	margin-top: 0 !important;
	margin: 0 auto;
}
.el-date-picker{
	left: 7% !important;	
}
.el-input__prefix{
	display: none;
}
.el-input__suffix{
	left: 0;
}
.releaseSearch .el-textarea__inner::-webkit-input-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner:-moz-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner::-moz-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner:-ms-input-placeholder{
    color:#000;
}
</style>
<style scoped>
.disable{
	position: absolute;
	width: 100%;
	height: 280px;
	top: 0;
	z-index: 990;
	overflow: scroll;
}
.main{
    margin-top: 20px;
}
.addtext {
    text-align: center;
    padding: 20px 0;
    margin-bottom: 20px;
    font-size: .8rem;
    color: rgb(130, 130, 130);
    letter-spacing: 1px;
}
.releaseSearch .danger {
    font-size: 0.625rem;
    color: red;
    margin-top: 5px;
}
.title {
    margin-top: 15px;
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
}
.describe {
    width: 100%;
    margin: 0 auto;
}
.describe span{
	font-size: .8rem;
	color: #606266;
}
.time {
    border-bottom: solid 1px rgb(230, 230, 230);
	height: 3rem;
}
.time p {
	display: inline-block;
    width: 45%;
    font-size: .8rem;
	line-height: 3rem;
    float: left;
}
.time p img{
	width: .9rem;
    vertical-align: middle;
    margin-right: .3rem;	
}
.block{
	width: 55%;
	float: right;
}
.loseplace {
    border-bottom: solid 1px rgb(230, 230, 230);
    height: 3rem;
}
.loseplace span{
	display: inline-block;
    width: 35%;
    font-size: .8rem;
	line-height: 3rem;
    float: left;
}
.loseplace span img{
	width: .9rem;
    vertical-align: middle;
    margin-right: .3rem;
}
.loseplace p {
	width: 65%;
	height: 3rem;
	overflow: hidden;
	float: right;
	text-align: right;
    font-size: 0.875rem;
	line-height: 3rem;
}
.loseplace p:nth-child(2) {
    font-size: 0.75rem;
    line-height: 3rem;
    color: #999999;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.petphoto .delete {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 45px;
    left: 50px;
}
.petphoto .delete1 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 45px;
    left: 130px;
}
.petphoto .delete2 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 45px;
    left: 210px;
}

.petphoto {
    border-bottom: solid 1px rgb(230, 230, 230);
    padding-bottom: 10px;
    position: relative;
}
.petphoto p {
	display: inline-block;
    width: 100%;
    font-size: .8rem;
	line-height: 3rem;
}
.petphoto p img{
	width: .9rem !important;
	height: auto !important;
    vertical-align: middle;
    margin-right: .3rem !important;	
    margin-left: 0 !important;	
}
.petphoto img {
    object-fit:cover;
    width: 60px;
    height: 60px;
    margin-right: 15px;
}

.el-message {
    width: 80%;
}
.head_img img {
    width: 60px;
    height: 60px;
}
.hiddenInput {
    display: none;
}
.hiddenInput1 {
    display: none;
}
.hiddenInput2 {
    display: none;
}
.main {
    position: absolute;
    top: 55px;
    bottom: 0;
    width: 100%;
    /*height: 100%;*/
    overflow: hidden;
/*    touch-action: none;*/
}

@media screen and (max-width: 321px) {
	.petphoto .delete,.petphoto .delete1,.petphoto .delete2 {
	    top: 32px;
	}
	.disable{
		height: 240px;
	}

}
</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/lostpetinfo.vue